/**
 * Constants for ProductionReport feature
 */

export const COLUMN_MODES = {
  full: "full",
  compact: "compact",
};

export const GALLONS_PER_ACRE_FOOT = 325851;

export const DETAIL_COLUMNS = [
  { id: "cuwcd_well_number", label: "File No", align: "left", sticky: true },
  { id: "state_well_number", label: "State #", align: "left" },
  { id: "well_name", label: "Well Name", align: "left" },
  { id: "agg_system_name", label: "Agg System", align: "left" },
  { id: "report_year", label: "Year", align: "left" },
  { id: "aquifer_name", label: "Aquifer", align: "left" },
  { id: "h_permit_af", label: "Hist. Permit (ac-ft)", align: "right" },
  { id: "o_permit_af", label: "Oper. Permit (ac-ft)", align: "right" },
  { id: "total_permit_af", label: "Total Permit (ac-ft)", align: "right" },
  { id: "jan", label: "Jan", align: "right", monthly: true },
  { id: "feb", label: "Feb", align: "right", monthly: true },
  { id: "mar", label: "Mar", align: "right", monthly: true },
  { id: "apr", label: "Apr", align: "right", monthly: true },
  { id: "may", label: "May", align: "right", monthly: true },
  { id: "jun", label: "Jun", align: "right", monthly: true },
  { id: "jul", label: "Jul", align: "right", monthly: true },
  { id: "aug", label: "Aug", align: "right", monthly: true },
  { id: "sep", label: "Sep", align: "right", monthly: true },
  { id: "oct", label: "Oct", align: "right", monthly: true },
  { id: "nov", label: "Nov", align: "right", monthly: true },
  { id: "dec", label: "Dec", align: "right", monthly: true },
  { id: "ytd_gal", label: "YTD (gal)", align: "right" },
  { id: "remaining_gal", label: "Rem. (gal)", align: "right", computed: true },
  { id: "ytd_af", label: "YTD (ac-ft)", align: "right" },
  { id: "remaining_af", label: "Rem. (ac-ft)", align: "right", computed: true },
  {
    id: "pct_permit",
    label: "% Permit",
    align: "right",
    computed: true,
    minWidth: 140,
  },
];

export const EXCEL_COLUMNS = [
  {
    id: "cuwcd_well_number",
    label: "File No",
    align: "left",
    sticky: true,
    stickyIndex: 0,
  },
  {
    id: "agg_system_name",
    label: "Agg System",
    align: "left",
    sticky: true,
    stickyIndex: 1,
  },
  { id: "state_well_number", label: "State #", align: "left" },
  { id: "well_name", label: "Well Name", align: "left" },
  { id: "report_year", label: "Year", align: "left" },
  { id: "aquifer_name", label: "Aquifer", align: "left" },
  { id: "h_permit_af", label: "Hist. Permit (ac-ft)", align: "right" },
  { id: "o_permit_af", label: "Oper. Permit (ac-ft)", align: "right" },
  { id: "total_permit_af", label: "Total Permit (ac-ft)", align: "right" },
  { id: "jan", label: "Jan", align: "right", monthly: true },
  { id: "feb", label: "Feb", align: "right", monthly: true },
  { id: "mar", label: "Mar", align: "right", monthly: true },
  { id: "apr", label: "Apr", align: "right", monthly: true },
  { id: "may", label: "May", align: "right", monthly: true },
  { id: "jun", label: "Jun", align: "right", monthly: true },
  { id: "jul", label: "Jul", align: "right", monthly: true },
  { id: "aug", label: "Aug", align: "right", monthly: true },
  { id: "sep", label: "Sep", align: "right", monthly: true },
  { id: "oct", label: "Oct", align: "right", monthly: true },
  { id: "nov", label: "Nov", align: "right", monthly: true },
  { id: "dec", label: "Dec", align: "right", monthly: true },
  { id: "ytd_gal", label: "YTD (gal)", align: "right" },
  { id: "remaining_gal", label: "Rem. (gal)", align: "right", computed: true },
  { id: "ytd_af", label: "YTD (ac-ft)", align: "right" },
  { id: "remaining_af", label: "Rem. (ac-ft)", align: "right", computed: true },
  {
    id: "pct_permit",
    label: "% Permit",
    align: "right",
    computed: true,
    minWidth: 140,
  },
];

export const COLUMN_FILTER_CONFIG = {
  report_year: { key: "years", label: "Year" },
  aquifer_name: { key: "aquifers", label: "Aquifer" },
  agg_system_name: { key: "aggSystems", label: "Agg System" },
  cuwcd_well_number: { key: "wells", label: "File No" },
  state_well_number: { key: "stateWells", label: "State #" },
  well_name: { key: "wellNames", label: "Well Name" },
};

export const DEFAULT_COLUMN_FILTERS = {
  years: [],
  aquifers: [],
  aggSystems: [],
  wells: [],
  stateWells: [],
  wellNames: [],
};
